import { render, staticRenderFns } from "./RepresentativeCommisionOnShipping.vue?vue&type=template&id=15a942fa&"
import script from "./RepresentativeCommisionOnShipping.vue?vue&type=script&lang=ts&"
export * from "./RepresentativeCommisionOnShipping.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports